import type { ServerMonitoringSnapshot } from '../types/server';

export function isMonitoringStale(
  snapshot: ServerMonitoringSnapshot | null | undefined,
  now = Date.now(),
): boolean {
  if (!snapshot || snapshot.staleReason) return true;
  return new Date(snapshot.staleAfter).getTime() <= now;
}
